import { api } from "../api";

export const getEngineer = async () => {
  let url = "/engineers";
  return await api.get(url);
};

export const getEngineerById = async (id) => {
  let url = `/engineers/${id}`;
  return await api.get(url);
};

export const deleteEngineer = async (id) => {
  let url = `/engineers/${id}`;
  return await api.delete(url);
};

export const updateEngineer = async (id, engineerData) => {
  let url = `/engineers/${id}`;
  return await api.put(url, engineerData);
};

export const createEngineer = async (engineerData) => {
  let url = `/engineers`;
  return await api.post(url, engineerData);
};

export const getEngineerHub = async (engineerId) => {
  return await api.get(`/engineers/${engineerId}/hub`);
};

export const updateEngineerOperationalInfo = async (engineerId, data) => {
  return await api.put(`/engineers/${engineerId}/operational-info`, data);
};

export const createEngineerCredential = async (engineerId, data) => {
  return await api.post(`/engineers/${engineerId}/credentials`, data);
};

export const updateEngineerCredential = async (engineerId, credentialId, data) => {
  return await api.put(`/engineers/${engineerId}/credentials/${credentialId}`, data);
};

export const deleteEngineerCredential = async (engineerId, credentialId) => {
  return await api.delete(`/engineers/${engineerId}/credentials/${credentialId}`);
};

export const revealEngineerCredentialPassword = async (engineerId, credentialId, action = "VIEWED") => {
  return await api.post(`/engineers/${engineerId}/credentials/${credentialId}/reveal`, { action });
};

export const createEngineerLink = async (engineerId, data) => {
  return await api.post(`/engineers/${engineerId}/links`, data);
};

export const updateEngineerLink = async (engineerId, linkId, data) => {
  return await api.put(`/engineers/${engineerId}/links/${linkId}`, data);
};

export const deleteEngineerLink = async (engineerId, linkId) => {
  return await api.delete(`/engineers/${engineerId}/links/${linkId}`);
};

export const createEngineerDocument = async (engineerId, data) => {
  return await api.post(`/engineers/${engineerId}/documents`, data);
};

export const updateEngineerDocument = async (engineerId, documentId, data) => {
  return await api.put(`/engineers/${engineerId}/documents/${documentId}`, data);
};

export const deleteEngineerDocument = async (engineerId, documentId) => {
  return await api.delete(`/engineers/${engineerId}/documents/${documentId}`);
};

export const createEngineerComment = async (engineerId, data) => {
  return await api.post(`/engineers/${engineerId}/comments`, data);
};

export const deleteEngineerComment = async (engineerId, commentId) => {
  return await api.delete(`/engineers/${engineerId}/comments/${commentId}`);
};
